export default "__VITE_ASSET__BHqHEYxP__"